import { createContext } from 'react';

import { OptimizationWorkloadPod } from '@cast/types';

import { PreparedWorkload } from 'features/workload-optimization';
import { useWorkloadScalingPoliciesQuery } from 'hooks/queries/workload-optimization';

import { IsNamespaceWritable } from '../_hooks/permissions/makeIsNamespaceWritable';
import { useCurrentWorkloadMetrics } from '../_hooks/useCurrentWorkloadMetrics';

export type WorkloadDetailsState = Omit<
  ReturnType<typeof useCurrentWorkloadMetrics>,
  'workload' | 'pods'
> & {
  workload?: PreparedWorkload;
  pods: OptimizationWorkloadPod[];
  verticalScalingPolicies: ReturnType<typeof useWorkloadScalingPoliciesQuery>;
  isNamespaceWritable: IsNamespaceWritable;
};

export const WorkloadDetailsContext = createContext<WorkloadDetailsState>(
  {} as never
);
